/* eslint-disable */
import TextDetection from './reducer';
import operation from './operation';
export { operation };
export default TextDetection;
